module.exports = __webpack_public_path__ + "Roboto-Thin.90d3804f0231704c15cc.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff
// module id = 253
// module chunks = 2